import { Permissions } from "../models/enums/permissions";
import { AppUser } from "../models/utilities/app-user";
import { ServiceCenter } from "../models/utilities/service-center";

export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_USER_SERVICECENTER = 'SET_USER_SERVICECENTER';
export const SET_OVERRIDE_PERMISSIONS = 'SET_OVERRIDE_PERMISSIONS';

/**
 * Action creator for setting the users service center
 * @param sc The user's service center to make active
 */
export const setUserServiceCenter = (sc: ServiceCenter) => ({
    type: SET_USER_SERVICECENTER,
    payload: sc
});

/**
 * Action creator for setting the current app user
 * @param user The user to set as the current user
 */
export const setUserInfo = (user : AppUser) => ({
    type: SET_USER_INFO,
    payload: user
});

/**
 * Action creator for overriding the current permissions
 * @param user The user to set as the current user
 */
export const setOverridePermissions = (perms : Permissions[]) => ({
    type: SET_OVERRIDE_PERMISSIONS,
    payload: perms
});
